import { atom } from 'jotai'
import {ThreadInterface} from "./interfaces/common"
import {UploadFile} from "./pages/AiThreads/interfaces";

export const unreadChatsAtom = atom<number>(0);

export const unreadCoachChatsAtom = atom<Array<string>>([]);

export const threadsAtom = atom<Array<ThreadInterface>>([]);

interface CustomerCategoryInterface {
  id: string;
  name: string;
}

export const customerCategoryAtom = atom<Array<CustomerCategoryInterface>>([]);

export const focusAreasAtom = atom<number>(0);

export const pictureAtom = atom<string|null>(null);

export const languageAtom = atom<string>(localStorage.getItem('language') === 'sv' ? 'sv' : 'en');
export const onboardedAtom = atom<string|null>(null);
export const customerSurveysAtom = atom<number>(0);

export const uploadFileAtom = atom<UploadFile[]>([]);
export const departmentAtom = atom<boolean>(false);

interface ToastInterface {
  type?: "success" | "error" | "warning" | "info";
  autoClose?: number;
  position?: "top-right" | "top-left" | "top-center";
  theme?: "light" | "dark" | "colored";
  infoType?: "created" | "completed";
  transition?: any,
  text: string;
}

export const toastAtom = atom<ToastInterface|null>(null);